import { useState } from "react";
import { Popover } from "antd";
import PropTypes from "prop-types";
import styled from "styled-components";
import { InfoIcon } from "../../assets/icons";

export const PopoverLabelWrapper = styled.span`
  display: flex;
  align-items: center;
  color: #0c53bb;
  cursor: pointer;
  white-space: ${props => props.type === 'Esign' ? 'nowrap' : ''};

  .label-text {
    margin-right: 4px;
    font-size: 13px;
    font-weight: 400;
    .label-icon {
    }
  }
`;

const STATUS_MAP = {
  Esign: [
    { color: "#16B361", label: "Signed" },
    { color: "#0C53BB", label: "Pending" },
    { color: "gray", label: "Queued" },
  ],
  DocumentList: [
    { color: "#0C53BB", label: "Review Pending" },
    { color: "#CD5F24", label: "Rework Requested" },
    { color: "#16B361", label: "Approved" },
  ],
};

const StatusBreakdownPopover = ({ type }) => {
  const [show, setShow] = useState(false);
  const items = STATUS_MAP[type] || [];

  const content = (
    <div>
      {items.map((item) => (
        <div
          key={item.label}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 8,
            color: "#48566b",
            fontSize: "13px",
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: item.color,
              color: "#48566B",
            }}
          />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );

  const labelText =
    type === "Esign" ? "View Workflow Breakdown" : "View Status Breakdown";

  return (
    <PopoverLabelWrapper
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      type={type}
    >
      <span className="label-text">{labelText}</span>
      <Popover
        content={content}
        placement="top"
        styles={{
          body: {
            minWidth: 120,
          },
        }}
        open={show}
      >
        <span
          className="label-icon"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <InfoIcon />
        </span>
      </Popover>
    </PopoverLabelWrapper>
  );
};

StatusBreakdownPopover.propTypes = {
  type: PropTypes.oneOf(["Esign", "DocumentList"]).isRequired,
};

export default StatusBreakdownPopover;
